import { Component, inject, OnInit } from '@angular/core';

import { ILanguage } from 'projects/shared/lib/interfaces/language/language.interface';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { LanguageService } from 'projects/shared/lib/services/infrastructure/language/language.service';

@Component({
  selector: 'app-language-button',
  imports: [],
  templateUrl: './language-button.component.html',
  styleUrls: ['./language-button.component.scss']
})
export class LanguageButtonComponent implements OnInit {
  private readonly languageService: LanguageService;
  public currentLanguage: ILanguage | undefined;
  public showLanguageSelectionButton: boolean | undefined;

  public constructor() {
    this.languageService = inject(LanguageService);
  }

  public ngOnInit(): void {
    this.currentLanguage = this.languageService.currentLocaleGet();
    this.showLanguageSelectionButton = Boolean(ENVIRONMENT.navTopMenu.showLanguageSelectionButton && (this.languageService.configuredLanguageListGet().length > 1));
  }
}
